/**
 * Bootstrap the app (8-ball wide)
 *
 * This will include things like the shared header
 * as well as kicking off the template bundler,
 * site-wide error handling, and notifications.:i
 */
// this will be replaced by specific polyfills thanks to babel `useBuiltins: 'entry'`
import '@babel/polyfill'
import './lib/webpack-setup' // needed for the import() stuff to work
import { init as initializeI18n } from 'pp-react-l10n'

// various libs needed to start the app
import { logMissingContent } from './lib/errors/content'
import {
  setupGlobalEventHandlers,
  loadGriffinMetadata,
  applyPolyfill,
} from './lib/global' // global click handlers, printing, analytics, etc.
// import "ngRL-AjaxChallengeInterceptor" provided by rate limiter team here so it can be used in our app to protect vulnerable routes

import fraudNet from './lib/fraudNet'

export function setup() {
  return loadGriffinMetadata()
}

// to support 'append' on Windows
applyPolyfill([
  Element.prototype,
  Document.prototype,
  DocumentFragment.prototype,
])

// all sorts of stuff like error handling, analytics, etc
setupGlobalEventHandlers()

// initialize content
// load the content in <script id="react-messages" />
initializeI18n({ onContentMissing: logMissingContent })

// load fraudNet client side tracking script and data/config section
// eslint-disable-next-line
fraudNet.trigger(PAYPAL.ulData)
